import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setSent(true);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="forgot-page" className="min-h-screen pt-28 pb-20 px-6 flex flex-col items-center bg-sand">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Logo tone="dark" className="h-16 w-auto mx-auto" />
        </div>
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <h1 className="font-serif text-3xl font-light mb-3">Check your inbox</h1>
            <p className="text-charcoal/60 text-sm">
              If an account exists for <strong>{email}</strong>, we've sent a secure reset link. It's valid for one hour.
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 overline mt-8 hover:opacity-60 transition-opacity">
              <ArrowLeft size={15} /> Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-3xl font-light text-center mb-2">Forgot password</h1>
            <p className="text-charcoal/55 text-sm text-center mb-8">Enter your email and we'll send a reset link.</p>
            {err && <p className="text-destructive text-sm text-center mb-4" data-testid="forgot-error">{err}</p>}
            <form onSubmit={submit} className="space-y-6">
              <div>
                <label className="overline text-charcoal/60">Email</label>
                <input
                  data-testid="forgot-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-transparent border-b border-charcoal/30 py-2.5 focus:outline-none focus:border-charcoal"
                />
              </div>
              <button data-testid="forgot-submit" disabled={busy} className="w-full bg-ocean text-sand py-4 overline hover:opacity-90 transition-opacity disabled:opacity-50">
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <Link to="/login" className="inline-flex items-center gap-2 overline mt-8 hover:opacity-60 transition-opacity">
              <ArrowLeft size={15} /> Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
